export default {
    computed: {
      getCodeList(){
        return (codeName)=> {
          return this.$store.getters['dropdown/dataprovider'][codeName]
        }
      },
      getCodeValueByKey(codeName, key, value, find){
        return (codeName, key, value, find)=>{
          var codeList = this.getCodeList(codeName);
          var result = null;
          codeList.forEach(x => {
            if(x[key] == value){
              result = x[find];
              return
            }
          });
          return result;
        }
      },
      getCodeByKey(codeName, key, value){
        return (codeName, key, value, find)=>{
          var codeList = this.getCodeList(codeName);
          var result = null;
          codeList.forEach(x => {
            if(x[key] == value){
              
              result = x;
              return
            }
          });
          return result;
        }
      }
    },
    methods: {
    }
  }
  